/**
 * A small range of wavelengths in the visible spectrum
 */
define(function() {
    SpectrumColor = function(color, startWavelength, endWavelength) {
        this.color = color;
        this.startWavelength = startWavelength;
        this.endWavelength = endWavelength;
    };
    return SpectrumColor;
});
